module.exports = __webpack_public_path__ + "static/img/Library.98eebc3.png";